import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Col, Layout, Row } from 'tea-component';
import TopFilter from './widgets/TopFilter';
import TrendsList from './widgets/TrendsList';
import DauCard from './widgets/DauCard';
import TotalHeatCard from './widgets/TotalHeatCard';
import moment from 'moment';
import { getTrendsHotList } from '../../services/trends';
import FilterBoxCommon from '../../components/FilterBoxCommon';
import { connect, useIntl } from 'umi';
import '@/pages/opinion/assets/scss/pages/trends/index.scss';
import { downloadAction } from '../../components/DownloadCommon/download-page';
import { useInitBuriedPointInfo } from '../../operationLog/buriedPoint';
import googleTrends from '@op/operationLog/pages/googleTrends';
import twitterTrends from '@op/operationLog/pages/twitterTrends';
import ContentBody from '../../components/ContentBody';
const { Content } = Layout;
/**
 * 热点页面。
 * 页面打点在TopFilter组件中
 * @param props
 * @returns
 */
function Trends({
  gameInfo,
  wholeGameInfo,
}: {
  gameInfo: any;
  wholeGameInfo: any;
}) {
  const [params, setParams] = useState<{
    start_time: string;
    end_time: string;
    region: string;
    origin: 'google' | 'twitter';
  }>({
    start_time: moment().subtract(7, 'days').format('YYYY-MM-DD'),
    end_time: moment().subtract(1, 'days').format('YYYY-MM-DD'),
    region: '',
    origin: 'google',
  });
  useInitBuriedPointInfo({
    buriedPoint: params.origin === 'google' ? googleTrends : twitterTrends,
  });
  const pageSize = 10; // 分页暂时是固定的，统一使用这个数据
  const [pageNum, setPageNum] = useState(1); // 页码
  const [searchText, setSearchText] = useState('');
  const isLoading = useRef(false);
  const [loading, setLoading] = useState(false);
  const [resetLoading, setResetLoading] = useState(false);

  const [trendsMap, setTrendsMap] = useState({ google: [], twitter: [] });
  const [totalMap, setTotalMap] = useState({ google: -1, twitter: -1 });

  const [language, setLanguage] = useState(['origin']);
  const [canUpdate, setCanUpdate] = useState(false);

  const getTrendsInfo = (key: 'google' | 'twitter'): [Array<any>, number] => {
    return [trendsMap[key], totalMap[key]];
  };

  const stopScrollRef = useRef(false);

  /**
   * 列表数据这里请求，其他数据可以考虑到组件内请求，因为列表有太多参数在外面了
   * @param pageNum          页码
   * @param value            需要重置的请求参数
   * @param isDataReset      是否需要重置数据
   * @param noResetLoading   不进行列表全局loading，主要是因为修改注解，只重置数据，不loading
   * @returns
   */
  function getTrendsList(
    pageNum: number,
    value?: { [key: string]: any },
    isDataReset?: boolean,
    noResetLoading?: boolean,
  ) {
    let paramsInfo = {
      page: pageNum,
      page_size: pageSize,
      search_text: searchText,
      ...params,
    };
    // const trendsList = paramsInfo.origin === 'google' ? googleTrendsList : twitterTrendsList;
    const key: any = paramsInfo.origin;
    const [trendsList, total] = getTrendsInfo(key);
    if (value) {
      paramsInfo = { ...paramsInfo, ...value };
    } else if (!value && !isDataReset && total === trendsList.length) {
      // 没有value参数和重置数据操作，并且总条数与列表数相同了，那么就不需要请求了【主要防止滚动加载的情况】
      return;
    }
    isLoading.current = true;
    setLoading(true);
    if (!noResetLoading) {
      // 设置开启滚动加载能力
      stopScrollRef.current = false;
      setResetLoading(!!isDataReset);
    }
    getTrendsHotList(paramsInfo)
      .then((data: any) => {
        let mapKey: any = paramsInfo.origin;
        const [defaultTrendsList] = getTrendsInfo(mapKey);
        let result: Array<any> = isDataReset ? [] : defaultTrendsList;
        let list = data?.list || [];
        if (Array.isArray(list) && list?.length > 0) {
          if (isDataReset) {
            result = list;
          } else {
            result = [...result, ...list];
          }
          // 在注解修改获取数据阶段，不去重置pageNum字段
          if (!noResetLoading) {
            setPageNum(pageNum);
          }
          setCanUpdate(!!data?.can_edit);
          setTotalMap({ ...totalMap, [mapKey]: data?.total });
        } else {
          stopScrollRef.current = true;
        }
        let resultMap = { ...trendsMap, [mapKey]: result };
        setTrendsMap(resultMap);
      })
      .finally(() => {
        setResetLoading(false);
        setLoading(false);
        isLoading.current = false;
      });
  }

  // 设置了注解后获取数据的方法
  function setCitationReset() {
    getTrendsList(1, { page_size: pageNum * pageSize }, true, true);
  }
  const scrollRef = useRef<any>(null);
  // 滚动下拉加载数据
  useEffect(() => {
    const element = scrollRef.current;
    const handleScroll = () => {
      let scrollTop = element?.scrollTop || 0;
      let windowHeight = element?.clientHeight || 0;
      let scrollHeight = element?.scrollHeight || 0;
      let instance = scrollHeight - scrollTop - windowHeight;
      //滚动条到底部的条件
      if (instance < 50 && !isLoading.current && !stopScrollRef.current) {
        getTrendsList(pageNum + 1);
      }
    };
    if (element) {
      element?.addEventListener('scroll', handleScroll); // 监听页面滚动*/

      return () => {
        element?.removeEventListener('scroll', handleScroll);
      };
    }
  }, [getTrendsList, pageNum]);

  /**
   * 修改了条件后，判断是否需要加载数据
   * 首次获取数据有topFilter组件触发这个方法获取
   * @param value
   */
  const changeCondition = (value: { [key: string]: string }) => {
    // 做个检测，如果没有改变值，就不去设置params而触发请求
    let flag = false;
    for (const key in value) {
      const newEle = value[key];
      const oldEle = params[key];
      if (Array.isArray(newEle)) {
        flag = newEle.every((item, index) => item === oldEle[index]);
      } else if (oldEle !== newEle) {
        flag = true;
      }
    }
    if (flag) {
      setParams({ ...params, ...value });
      getTrendsList(1, value, true);
    }
  };
  const { formatMessage } = useIntl();
  const [renderTrendsList, total] = useMemo(() => {
    return getTrendsInfo(params.origin);
  }, [params.origin, trendsMap]);

  return (
    <Content className="dbo-page dbo-trends" ref={scrollRef}>
      <ContentBody
        contentHeard={
          <Content.Header title={formatMessage({ id: 'Google & X Trends' })} />
        }
      >
        <TopFilter
          params={params}
          gameInfo={gameInfo}
          changeCondition={changeCondition}
        ></TopFilter>
        <section style={{ marginTop: 12 }}>
          <Row>
            <Col span={12}>
              <DauCard params={params} wholeGameInfo={wholeGameInfo}></DauCard>
            </Col>
            <Col span={12}>
              <TotalHeatCard
                params={params}
                wholeGameInfo={wholeGameInfo}
              ></TotalHeatCard>
            </Col>
          </Row>
        </section>

        <FilterBoxCommon
          left={[{ key: 'languages' }]}
          right={[
            {
              key: 'search',
              defaultParams: {
                style: { width: 350, marginRight: 10 },
                placeholder: formatMessage({
                  id: 'Search by keywords or phrases.',
                }),
                onSearch: (value: string) => {
                  if (value !== searchText) {
                    setSearchText(value);
                    getTrendsList(1, { search_text: value }, true);
                  }
                },
                onClear: () => {
                  setSearchText('');
                  getTrendsList(1, { search_text: '' }, true);
                },
              },
            },
            {
              key: 'download',
              event: {
                onClick: () => {
                  const downloadLimit = 150000; //下载限制条数
                  const gameName = wholeGameInfo?.entity_name || '';
                  const fileName = `Opinions_${gameName}_Trends_${moment(
                    params.start_time,
                  ).format('YYYYMMDD')}_${moment(params.end_time).format(
                    'YYYYMMDD',
                  )}`;
                  downloadAction({
                    limit: downloadLimit,
                    fileName,
                    downLoadParams: {
                      ...params,
                      page: 1,
                      page_size: 1000,
                      search_text: searchText,
                    },
                    downloadFunc: 'getTrendsListDownload',
                  });
                },
              },
            },
          ]}
          onChange={function (value: any, key?: any) {
            if (key === 'languages') {
              setLanguage(value[key]);
            }
          }}
        ></FilterBoxCommon>

        <TrendsList
          loading={loading}
          resetLoading={resetLoading}
          language={language}
          trendsList={renderTrendsList}
          platform={params.origin}
          canUpdate={canUpdate}
          setCitationReset={setCitationReset}
          isLoadingCompleted={total === renderTrendsList.length}
        ></TrendsList>
      </ContentBody>
    </Content>
  );
}

export default connect((state: any) => {
  const { opinionCommon } = state;

  return {
    gameInfo: opinionCommon.gameInfo,
    wholeGameInfo: opinionCommon.wholeGameInfo,
  };
})(Trends);
